import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import isEmpty from 'lodash/isEmpty';

import Scene from '../Scene';
import { toVw, toVwTablet, toVwMobile } from '../../utils/styles';
import BigText from '../../components/BigText';
import Container from '../../components/Container';
import Indent from '../../components/Indent';
import StyledLink from '../../components/StyledLink';
import Cols from './components/AboutCols';
import Feature from './components/Feature';
import Clients from './components/Clients';
import Team from './components/Team/';
import mq from '@/utils/media-queries';
import Media from '../../components/Media';
import PreviewNextPage from '../../components/PreviewNextPage';
import AnimationOnPageLoadItem from '../../components/AnimationOnPageLoadItem';

const StyledScene = styled(Scene)`
  padding-top: ${toVw(288)};

  ${mq.tablet(css`
    padding-top: ${toVwTablet(288)};
  `)};

  ${mq.mobile(css`
    padding-top: ${toVwMobile(300)};
  `)};
`;

const Preface = styled(BigText)`
  margin-bottom: ${toVw(165)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(134)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(105)};
    font-size: ${toVwMobile(44)};
  `)};
`;

const Photo = styled(Media)`
  margin-bottom: ${toVw(216)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(216)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(80)};
  `)};
`;

const FEATURE_MARGIN_BOTTOM = 180;

const FeatureCols = styled(Cols)`
  margin-bottom: ${toVw(144)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(150)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(145)};
  `)};
`;

const StyledFeature = styled(Feature)`
  margin-bottom: ${toVw(FEATURE_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(FEATURE_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(120)};
  `)};
`;

const StyledClients = styled(Clients)`
  margin-bottom: ${toVw(258)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(180)};
  `)};
`;

const StyledTeam = styled(Team)`
  margin-bottom: ${toVw(264)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(264)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(180)};
  `)};
`;

const PartnersText = styled(BigText)`
  margin-bottom: ${toVw(284)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(252)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(294)};
    font-size: ${toVwMobile(44)};
  `)};
`;

class About extends React.Component {
  static propTypes = {
    aboutStore: PropTypes.object.isRequired,
    withTransition: PropTypes.bool,
    shouldHandleColors: PropTypes.bool,
  };

  componentDidMount() {
    this.props.aboutStore.load();
  }

  render() {
    const { aboutStore, ...rest } = this.props;

    const { photo, photo2, nextPreview, team, features, clients } = aboutStore.toJSON();

    return (
      <StyledScene dark {...rest}>
        <Container>
          <Indent>
            <AnimationOnPageLoadItem>
              <Preface>
                Agency with a&nbsp;wide range of&nbsp;experience in&nbsp;visual and digital identity. Our goal
                is&nbsp;to&nbsp;launch sharp <StyledLink to="/cases?category=branding">brands</StyledLink> and
                functional <StyledLink to="/cases?category=digital">digital</StyledLink> projects that solve
                client&rsquo;s problems.
              </Preface>
            </AnimationOnPageLoadItem>
          </Indent>
          <AnimationOnPageLoadItem>{!isEmpty(photo) && <Photo {...photo} />}</AnimationOnPageLoadItem>
          <Indent>
            {features &&
              features.length > 0 && (
                <FeatureCols>
                  {features.map((item, index) => (
                    <Cols.Col key={index}>
                      <StyledFeature {...item} />
                    </Cols.Col>
                  ))}
                </FeatureCols>
              )}
            {clients && clients.length > 0 && <StyledClients items={clients} />}
          </Indent>
          {/* {team && team.length > 0 && <StyledTeam items={team} photo={photo2} />} */}
          <Indent>
            <PartnersText>
              We also have partners in&nbsp;front-end development, lettering, 3D&nbsp;modelling, video
              production, environment and interior design, architecture, graphic design and photo.
            </PartnersText>
          </Indent>
        </Container>
        {nextPreview && <PreviewNextPage {...nextPreview} />}
      </StyledScene>
    );
  }
}

export default inject(stores => ({
  aboutStore: stores.store.aboutStore,
  teamStore: stores.store.team,
  featuresStore: stores.store.features,
  clientsStore: stores.store.clients,
}))(observer(About));



// WEBPACK FOOTER //
// ./src/scenes/About/index.js